
import React from 'react';

const WhatLexiWantsSection: React.FC = () => {
  const qualities = [
    {
      icon: 'ri-rocket-line',
      title: 'Matching Ambition',
      description: 'Someone whose drive and career trajectory matches her own professional excellence'
    },
    {
      icon: 'ri-heart-line',
      title: 'Family Values',
      description: 'A man who values family as much as she does - the Geraghtys are incredible people and family is everything'
    },
    {
      icon: 'ri-earth-line',
      title: 'Travel Partner',
      description: 'A companion who appreciates both Michelin stars and street food adventures'
    },
    {
      icon: 'ri-compass-line',
      title: 'Adventure Ready',
      description: 'Someone ready to explore the half of the world she hasn\'t seen yet'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Northern California Ties',
      description: 'Bonus points for NorCal roots - her amazing family would love to have her close'
    },
    {
      icon: 'ri-time-line',
      title: 'Ready for Real',
      description: 'No games, no casual dating - someone ready to build something meaningful with family at the center'
    }
  ];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            What Lexi Deserves
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            She spent her twenties building an empire while staying close to her incredible family. Now she's looking for someone who matches her energy, success, and family values.
          </p>
        </div>

        {/* Qualities Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {qualities.map((quality, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-100"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-slate-900 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${quality.icon} text-white text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-900 mb-3">
                    {quality.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {quality.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">
            Could You Be Her Perfect Match?
          </h3>
          <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
            She conquered the business world with her family's support and is ready to find someone equally amazing to share her incredible life with.
          </p>
          <button 
            onClick={() => document.getElementById('application')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-slate-100 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
          >
            Tell Lexi About Yourself
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhatLexiWantsSection;
